import { BasePage } from "@Tenants/Fun/Site/BasePage";

import "@Base/Home/_Bubbles.scss";
import "./Home.scss";

class HomePage extends BasePage
{
	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
	};
}

const home = new HomePage();